import React from 'react';
import Header from './common/header-component/header';
import Sidebar from './common/sidebar-component/sidebar';
import Footer from './common/footer';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Loader from './common/loader';
import { useUserPermisos } from './hooks/useUserPermisos';
import { PermisosProvider } from './common/permisos-context';

import active from '../auth/active';

active.checkSessionTime();

const AppLayout = ({children}) => {
    const activechk = () =>{
        active.activeSend()
    }

    const { permisos, usuario, loading } = useUserPermisos();

    return (
        <PermisosProvider value={{ permisos, usuario, loading }}>
            <Loader />
            <div className="page-wrapper" onClick={ activechk}>
                <div className="page-body-wrapper">
                    <Header />
                    <Sidebar
                        permisos={permisos}
                        loading={loading}
                    />
                    <div className="page-body">
                        {children}
                    </div>
                    {/* <Footer /> */}
                </div>
            </div>
            <ToastContainer />
        </PermisosProvider>
    );
}

export default AppLayout;
